/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CapacitiesList,
    CapacitiesListFromJSON,
    CapacitiesListToJSON,
    CapacitiesRow,
    CapacitiesRowFromJSON,
    CapacitiesRowToJSON,
} from '../models';

export interface GetCapacitiesRequest {
    officeIds: Array<number>;
    driverId?: number;
    officeId?: number;
}

export interface UpdateCapacityRequest {
    officeId: number;
    driverId: number;
    capTrips: number;
}

/**
 * 
 */
export class CapacityApi extends runtime.BaseAPI {

    /**
     * 乗務員の上限取得
     */
    async getCapacitiesRaw(requestParameters: GetCapacitiesRequest): Promise<runtime.ApiResponse<CapacitiesList>> {
        if (requestParameters.officeIds === null || requestParameters.officeIds === undefined) {
            throw new runtime.RequiredError('officeIds','Required parameter requestParameters.officeIds was null or undefined when calling getCapacities.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.officeIds) {
            queryParameters['office_ids'] = requestParameters.officeIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.driverId !== undefined) {
            queryParameters['driver_id'] = requestParameters.driverId;
        }

        if (requestParameters.officeId !== undefined) {
            queryParameters['office_id'] = requestParameters.officeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/capacity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CapacitiesListFromJSON(jsonValue));
    }

    /**
     * 乗務員の上限取得
     */
    async getCapacities(requestParameters: GetCapacitiesRequest): Promise<CapacitiesList> {
        const response = await this.getCapacitiesRaw(requestParameters);
        return await response.value();
    }

    /**
     * 上限設定
     */
    async updateCapacityRaw(requestParameters: UpdateCapacityRequest): Promise<runtime.ApiResponse<CapacitiesRow>> {
        if (requestParameters.officeId === null || requestParameters.officeId === undefined) {
            throw new runtime.RequiredError('officeId','Required parameter requestParameters.officeId was null or undefined when calling updateCapacity.');
        }

        if (requestParameters.driverId === null || requestParameters.driverId === undefined) {
            throw new runtime.RequiredError('driverId','Required parameter requestParameters.driverId was null or undefined when calling updateCapacity.');
        }

        if (requestParameters.capTrips === null || requestParameters.capTrips === undefined) {
            throw new runtime.RequiredError('capTrips','Required parameter requestParameters.capTrips was null or undefined when calling updateCapacity.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.capTrips !== undefined) {
            queryParameters['cap_trips'] = requestParameters.capTrips;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/capacity/offices/{office_id}/drivers/{driver_id}`.replace(`{${"office_id"}}`, encodeURIComponent(String(requestParameters.officeId))).replace(`{${"driver_id"}}`, encodeURIComponent(String(requestParameters.driverId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CapacitiesRowFromJSON(jsonValue));
    }

    /**
     * 上限設定
     */
    async updateCapacity(requestParameters: UpdateCapacityRequest): Promise<CapacitiesRow> {
        const response = await this.updateCapacityRaw(requestParameters);
        return await response.value();
    }

}
